import AbortService from "@rmp/core/services/abortService";
import BaseOrganizationController from "@rmp/core/api/base/baseOrganizationController";
import { withCaptcha } from "@rmp/core/services/captcha";

export class LegalEntityController extends BaseOrganizationController {
	constructor(private readonly abortService: AbortService) {
		super(abortService);
	}
	
	updateLegalEntityCounterpartyEmployee = this.api.counterparty.legalEntityEmployeeUpdateByLegalEntityId;
	updateOwnLegalEntityCounterpartyEmployee = this.api.own.counterpartyLegalEntityEmployeeUpdateByEmployeeId;
	
	createLegalEntityCounterpartyEmployee = this.api.counterparty.legalEntityEmployeeCreateByLegalEntityId;
	createOwnLegalEntityCounterpartyEmployee = this.api.own.counterpartyLegalEntityEmployeeCreateByAssignToAccount;
	
	getLegalEntitySuggestion = withCaptcha(this.api.counterparty.legalEntitySuggestionCompleteListByInn, () => this.abortService.getSignal());
	
	getLegalEntityCounterpartyByIdentifiers = this.api.counterparty.legalEntitySearchListByInn;
	
	checkLegalEntityCounterpartyIsExists = this.api.counterparty.legalEntityExistsListByInn;
	
	checkAccountExists = this.api.counterparty.legalEntityCheckAccountExistsCreate;
	
	getLegalEntityHeads = this.api.counterparty.legalEntityHeadListByLegalEntityId;
	getOwnLegalEntityHeads = this.api.own.counterpartyLegalEntityHeadList;
	
	getLegalEntityProfile = this.api.counterparty.legalEntityProfileListByLegalEntityId;
	
	checkLegalEntityProfile = this.api.counterparty.legalEntityProfileCheckCreate;
	
	createLegalEntityProfile = this.api.counterparty.legalEntityProfileCreateByLegalEntityId;
	
	updateLegalEntityProfile = this.api.counterparty.legalEntityProfileUpdateByLegalEntityId;
	
	getEmployeeById = this.api.own.counterpartyLegalEntityEmployeeDetailByEmployeeId;
}
